$(document).ready(function() {

	const bubblesModule = {
        isLoading: false,
        init() {

            let bubbles = [];
            let layer;

            let width = document.getElementById("careers-bubbles-container").offsetWidth;
            let height = document.getElementById("careers-bubbles-container").offsetHeight;
            const speedMultiplier = 0.07; // Variable to control the speed of the bubbles

            const stage = new Konva.Stage({
                container: 'careers-bubbles-container',
                width: width,
                height: height
            });

            layer = new Konva.Layer();
            stage.add(layer);

            /*var bubblesData = [
                { color: '#66d8d0', radius: 60, text: '<div style="font-size:18px;color: #000;font-weight:bold">Titlu Job</div>', dx: 2, dy: 2 },
                { color: '#ffbd69', radius: 82, text: '<div style="font-size:18px;color:#000"><b>Angajăm</b><br>Ingénieur<br>Synthèse<br>Technique Vie<br>Série Powertrain</div>', dx: 3, dy: 3 },
                { color: '#66d8d0', radius: 100, text: '<div style="font-size:18px;color:#000;"><b>Recrutăm intern</b><br>pentru Analiza<br>numerică<br>automatizată a<br>schemelor electrice</div>', dx: -2, dy: -2 },
                { color: '#66d8d0', radius: 60, text: '<div style="font-size:18px;color: #000;font-weight:bold">Titlu Job</div>', dx: 2, dy: 2 },
                { color: '#ffbd69', radius: 82, text: '<div style="font-size:18px;color:#000"><b>Angajăm</b><br>Ingénieur<br>Synthèse<br>Technique Vie<br>Série Powertrain</div>', dx: 3, dy: 3 },
                { color: '#66d8d0', radius: 100, text: '<div style="font-size:18px;color:#000;"><b>Recrutăm intern</b><br>pentru Analiza<br>numerică<br>automatizată a<br>schemelor electrice</div>', dx: -2, dy: -2 },
                { color: '#66d8d0', radius: 60, text: '<div style="font-size:18px;color: #000;font-weight:bold">Titlu Job</div>', dx: 2, dy: 2 },
                { color: '#ffbd69', radius: 82, text: '<div style="font-size:18px;color:#000"><b>Angajăm</b><br>Ingénieur<br>Synthèse<br>Technique Vie<br>Série Powertrain</div>', dx: 3, dy: 3 },
                { color: '#66d8d0', radius: 100, text: '<div style="font-size:18px;color:#000;"><b>Recrutăm intern</b><br>pentru Analiza<br>numerică<br>automatizată a<br>schemelor electrice</div>', dx: -2, dy: -2 },
                { color: '#66d8d0', radius: 60, text: '<div style="font-size:18px;color: #000;font-weight:bold">Titlu Job</div>', dx: 2, dy: 2 },
                { color: '#ffbd69', radius: 82, text: '<div style="font-size:18px;color:#000"><b>Angajăm</b><br>Ingénieur<br>Synthèse<br>Technique Vie<br>Série Powertrain</div>', dx: 3, dy: 3 },
                { color: '#66d8d0', radius: 100, text: '<div style="font-size:18px;color:#000;"><b>Recrutăm intern</b><br>pentru Analiza<br>numerică<br>automatizată a<br>schemelor electrice</div>', dx: -2, dy: -2 },
                { color: '#66d8d0', radius: 60, text: '<div style="font-size:18px;color: #000;font-weight:bold">Titlu Job</div>', dx: 2, dy: 2 },
                { color: '#ffbd69', radius: 82, text: '<div style="font-size:18px;color:#000"><b>Angajăm</b><br>Ingénieur<br>Synthèse<br>Technique Vie<br>Série Powertrain</div>', dx: 3, dy: 3 },
                { color: '#66d8d0', radius: 100, text: '<div style="font-size:18px;color:#000;"><b>Recrutăm intern</b><br>pentru Analiza<br>numerică<br>automatizată a<br>schemelor electrice</div>', dx: -2, dy: -2 }
            ];

            if (width <= 768) {
                var bubblesData = [
                    { color: '#66d8d0', radius: 30, text: '<div style="font-size:14px;color: #000;font-weight:bold">Titlu Job</div>', dx: 2, dy: 2 },
                    { color: '#ffbd69', radius: 62, text: '<div style="font-size:14px;color:#000"><b>Angajăm</b><br>Ingénieur<br>Synthèse<br>Technique Vie<br>Série Powertrain</div>', dx: 3, dy: 3 },
                    { color: '#66d8d0', radius: 80, text: '<div style="font-size:14px;color:#000;"><b>Recrutăm intern</b><br>pentru Analiza<br>numerică<br>automatizată a<br>schemelor electrice</div>', dx: -2, dy: -2 },
                    { color: '#66d8d0', radius: 30, text: '<div style="font-size:14px;color: #000;font-weight:bold">Titlu Job</div>', dx: 2, dy: 2 },
                    { color: '#ffbd69', radius: 62, text: '<div style="font-size:14px;color:#000"><b>Angajăm</b><br>Ingénieur<br>Synthèse<br>Technique Vie<br>Série Powertrain</div>', dx: 3, dy: 3 },
                    { color: '#66d8d0', radius: 80, text: '<div style="font-size:14px;color:#000;"><b>Recrutăm intern</b><br>pentru Analiza<br>numerică<br>automatizată a<br>schemelor electrice</div>', dx: -2, dy: -2 },
                    { color: '#66d8d0', radius: 30, text: '<div style="font-size:14px;color: #000;font-weight:bold">Titlu Job</div>', dx: 2, dy: 2 },
                    { color: '#ffbd69', radius: 62, text: '<div style="font-size:14px;color:#000"><b>Angajăm</b><br>Ingénieur<br>Synthèse<br>Technique Vie<br>Série Powertrain</div>', dx: 3, dy: 3 },
                    { color: '#66d8d0', radius: 80, text: '<div style="font-size:14px;color:#000;"><b>Recrutăm intern</b><br>pentru Analiza<br>numerică<br>automatizată a<br>schemelor electrice</div>', dx: -2, dy: -2 },
                    { color: '#66d8d0', radius: 30, text: '<div style="font-size:14px;color: #000;font-weight:bold">Titlu Job</div>', dx: 2, dy: 2 },
                    { color: '#ffbd69', radius: 62, text: '<div style="font-size:14px;color:#000"><b>Angajăm</b><br>Ingénieur<br>Synthèse<br>Technique Vie<br>Série Powertrain</div>', dx: 3, dy: 3 },
                    { color: '#66d8d0', radius: 80, text: '<div style="font-size:14px;color:#000;"><b>Recrutăm intern</b><br>pentru Analiza<br>numerică<br>automatizată a<br>schemelor electrice</div>', dx: -2, dy: -2 },
                    { color: '#66d8d0', radius: 30, text: '<div style="font-size:14px;color: #000;font-weight:bold">Titlu Job</div>', dx: 2, dy: 2 },
                    { color: '#ffbd69', radius: 62, text: '<div style="font-size:14px;color:#000"><b>Angajăm</b><br>Ingénieur<br>Synthèse<br>Technique Vie<br>Série Powertrain</div>', dx: 3, dy: 3 },
                    { color: '#66d8d0', radius: 80, text: '<div style="font-size:14px;color:#000;"><b>Recrutăm intern</b><br>pentru Analiza<br>numerică<br>automatizată a<br>schemelor electrice</div>', dx: -2, dy: -2 }
                ];
            }*/

            bubbles = jobsBubbles.map(data => {

                var radiusVal = data.radius_small;
                
                if ($(window).width() > 767) {
                    radiusVal = data.radius_medium;
                }

                if ($(window).width() > 1100) {
                    radiusVal = data.radius_large;
                }

                if (1*radiusVal < 1) {
                    radiusVal = data.radius_small;
                }

                const radius = radiusVal;
                const x = radius + Math.random() * (width - 2 * radius);
                const y = radius + Math.random() * (height - 2 * radius);
                return { ...data, x, y, radius };
            });

            function createBubble(bubble) {
                const group = new Konva.Group({
                    x: bubble.x,
                    y: bubble.y,
                    draggable: true
                });

                const theme = document.documentElement.getAttribute('data-bs-theme');
                var radialColor = '#fff';
                if (theme === 'dark') {
                    radialColor = '#000';
                }

                const circle = new Konva.Circle({
                    radius: bubble.radius,
                    // fill: bubble.color
                    fillRadialGradientStartPoint: { x: 0, y: 0 },
                    fillRadialGradientStartRadius: 0,
                    fillRadialGradientEndPoint: { x: 0, y: 0 },
                    fillRadialGradientEndRadius: bubble.radius,
                    fillRadialGradientColorStops: [
                        0, radialColor,
                        0.8, radialColor,
                        1, bubble.color
                    ]
                });

                const content = document.createElement('div');
                content.innerHTML = bubble.text;
                content.className = 'bubble-content';
                content.style.width = `${bubble.radius * 2}px`;
                content.style.height = `${bubble.radius * 2}px`;
                content.style.left = `${bubble.x}px`;
                content.style.top = `${bubble.y}px`;
                content.style.transform = 'translate(-50%, -50%)';
                document.getElementById('careers-bubbles-container').appendChild(content);
                bubble.content = content;

                group.add(circle);

                group.on('dragstart', () => {
                    bubble.isDragging = true;
                });

                group.on('dragend', () => {
                    bubble.isDragging = false;
                    bubble.x = group.x();
                    bubble.y = group.y();
                    updateHTMLPosition(bubble);
                });

                group.on('dragmove', () => {
                    let newX = group.x();
                    let newY = group.y();

                    // Constrain the bubble within the canvas boundaries
                    if (newX - bubble.radius < 0) {
                        newX = bubble.radius;
                    }
                    if (newX + bubble.radius > width) {
                        newX = width - bubble.radius;
                    }
                    if (newY - bubble.radius < 0) {
                        newY = bubble.radius;
                    }
                    if (newY + bubble.radius > height) {
                        newY = height - bubble.radius;
                    }

                    bubble.x = newX;
                    bubble.y = newY;
                    updateHTMLPosition(bubble);

                    group.x(newX);
                    group.y(newY);

                    // Prevent other bubbles from being pushed out of the canvas
                    bubbles.forEach(otherBubble => {
                        if (otherBubble !== bubble) {
                            const dx = otherBubble.x - bubble.x;
                            const dy = otherBubble.y - bubble.y;
                            const distance = Math.sqrt(dx * dx + dy * dy);

                            if (distance < bubble.radius + otherBubble.radius) {
                                // Adjust position to keep both bubbles inside the canvas
                                const angle = Math.atan2(dy, dx);
                                const overlap = bubble.radius + otherBubble.radius - distance;
                                const shiftX = overlap * Math.cos(angle);
                                const shiftY = overlap * Math.sin(angle);

                                let newOtherX = otherBubble.x + shiftX;
                                let newOtherY = otherBubble.y + shiftY;

                                // Ensure other bubbles stay within the canvas boundaries
                                if (newOtherX - otherBubble.radius < 0) {
                                    newOtherX = otherBubble.radius;
                                }
                                if (newOtherX + otherBubble.radius > width) {
                                    newOtherX = width - otherBubble.radius;
                                }
                                if (newOtherY - otherBubble.radius < 0) {
                                    newOtherY = otherBubble.radius;
                                }
                                if (newOtherY + otherBubble.radius > height) {
                                    newOtherY = height - otherBubble.radius;
                                }

                                otherBubble.x = newOtherX;
                                otherBubble.y = newOtherY;
                                updateHTMLPosition(otherBubble);

                                otherBubble.group.x(newOtherX);
                                otherBubble.group.y(newOtherY);
                            }
                        }
                    });
                });

                group.on('mouseover', () => {
                    document.body.style.cursor = 'pointer';
                });

                group.on('mouseout', () => {
                    document.body.style.cursor = 'default';
                });

                // group.on('click touchstart', () => {
                group.on('click', () => {
                    if (bubble.url != '') {
                        window.location = bubble.url;
                    }
                });

                return group;
            }

            function updateHTMLPosition(bubble) {
                bubble.content.style.left = `${bubble.x}px`;
                bubble.content.style.top = `${bubble.y}px`;
            }

            bubbles.forEach(bubble => {
                const group = createBubble(bubble);
                bubble.group = group;
                layer.add(group);
            });

            layer.draw();

            updateRadialColor(document.documentElement.getAttribute('data-bs-theme'));

            function detectCollisions() {
                for (let i = 0; i < bubbles.length; i++) {
                    for (let j = i + 1; j < bubbles.length; j++) {
                        const bubble1 = bubbles[i];
                        const bubble2 = bubbles[j];

                        const dx = bubble2.x - bubble1.x;
                        const dy = bubble2.y - bubble1.y;
                        const distance = Math.sqrt(dx * dx + dy * dy);

                        if (distance < bubble1.radius + bubble2.radius) {
                            // Basic elastic collision response
                            const angle = Math.atan2(dy, dx);
                            const speed1 = Math.sqrt(bubble1.dx * bubble1.dx + bubble1.dy * bubble1.dy);
                            const speed2 = Math.sqrt(bubble2.dx * bubble2.dx + bubble2.dy * bubble2.dy);
                            const direction1 = Math.atan2(bubble1.dy, bubble1.dx);
                            const direction2 = Math.atan2(bubble2.dy, bubble2.dx);

                            bubble1.dx = speed2 * Math.cos(direction2 - angle);
                            bubble1.dy = speed2 * Math.sin(direction2 - angle);
                            bubble2.dx = speed1 * Math.cos(direction1 - angle);
                            bubble2.dy = speed1 * Math.sin(direction1 - angle);

                            // Move the bubbles apart
                            const overlap = 0.5 * (distance - bubble1.radius - bubble2.radius);
                            bubble1.x -= overlap * (bubble1.x - bubble2.x) / distance;
                            bubble1.y -= overlap * (bubble1.y - bubble2.y) / distance;
                            bubble2.x += overlap * (bubble1.x - bubble2.x) / distance;
                            bubble2.y += overlap * (bubble1.y - bubble2.y) / distance;

                            // Ensure the bubbles stay within canvas boundaries
                            if (bubble1.x - bubble1.radius < 0) {
                                bubble1.x = bubble1.radius;
                            }
                            if (bubble1.x + bubble1.radius > width) {
                                bubble1.x = width - bubble1.radius;
                            }
                            if (bubble1.y - bubble1.radius < 0) {
                                bubble1.y = bubble1.radius;
                            }
                            if (bubble1.y + bubble1.radius > height) {
                                bubble1.y = height - bubble1.radius;
                            }

                            if (bubble2.x - bubble2.radius < 0) {
                                bubble2.x = bubble2.radius;
                            }
                            if (bubble2.x + bubble2.radius > width) {
                                bubble2.x = width - bubble2.radius;
                            }
                            if (bubble2.y - bubble2.radius < 0) {
                                bubble2.y = bubble2.radius;
                            }
                            if (bubble2.y + bubble2.radius > height) {
                                bubble2.y = height - bubble2.radius;
                            }

                            bubble1.group.x(bubble1.x);
                            bubble1.group.y(bubble1.y);
                            bubble2.group.x(bubble2.x);
                            bubble2.group.y(bubble2.y);
                            updateHTMLPosition(bubble1);
                            updateHTMLPosition(bubble2);
                        }
                    }
                }
            }

            function update() {
                bubbles.forEach(bubble => {
                    if (!bubble.isDragging) {
                        bubble.x += bubble.dx * speedMultiplier;
                        bubble.y += bubble.dy * speedMultiplier;

                        // Boundary reflection
                        if (bubble.x - bubble.radius < 0 || bubble.x + bubble.radius > width) {
                            bubble.dx = -bubble.dx;
                        }
                        if (bubble.y - bubble.radius < 0 || bubble.y + bubble.radius > height) {
                            bubble.dy = -bubble.dy;
                        }

                        bubble.group.x(bubble.x);
                        bubble.group.y(bubble.y);
                        updateHTMLPosition(bubble);
                    }
                });

                detectCollisions();
                layer.batchDraw();
                requestAnimationFrame(update);
            }

            update();

            function updateRadialColor(theme) {
                const radialColor = theme === 'dark' ? '#000' : '#fff';
            
                bubbles.forEach(bubble => {
                    const circle = bubble.group.findOne('Circle');
                    if (circle) {
                        circle.fillRadialGradientColorStops([
                            0, radialColor,
                            0.8, radialColor,
                            1, bubble.color
                        ]);
                    }
                });
            
                layer.batchDraw();
            }

            window.addEventListener('resize', () => {
                newWidth = document.getElementById("careers-bubbles-container").offsetWidth;
                newHeight = document.getElementById("careers-bubbles-container").offsetHeight;
                stage.width(newWidth);
                stage.height(newHeight);

                // Scale the bubbles' positions to the new canvas size
                const scaleX = newWidth / width;
                const scaleY = newHeight / height;

                bubbles.forEach(bubble => {
                    bubble.x *= scaleX;
                    bubble.y *= scaleY;
                    bubble.group.x(bubble.x);
                    bubble.group.y(bubble.y);
                    updateHTMLPosition(bubble);
                });

                width = newWidth;
                height = newHeight;

                layer.batchDraw();
            });

            const observer = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'data-bs-theme') {
                        const newTheme = document.documentElement.getAttribute('data-bs-theme');
                        updateRadialColor(newTheme);
                    }
                });
            });
            
            observer.observe(document.documentElement, { attributes: true });

        },
    };

    if ($('#careers-bubbles-container').length) {
        bubblesModule.init();
    }

});





// WEBPACK FOOTER //
// ./resources/assets/js/modules/bubbles.js